import {
  ArrowLeft,
  EllipsisVertical,
  FileText,
  GitBranchPlus,
  ListFilter,
} from "lucide-react";
import { useTranslations } from "next-intl";
import type { ReactNode } from "react";

import { HeroVorgangActionFooter } from "./hero-vorgang-action-footer";
import { HeroVorgangDetailRail } from "./hero-vorgang-detail-rail";
import { HeroVorgangThread } from "./hero-vorgang-thread";
import { HeroVorgangUnknownPanel } from "./hero-vorgang-unknown-panel";
import type { HeroVorgangFixture } from "./module-inbox-vorgang-data";

function HeaderAction(props: {
  readonly label: string;
  readonly icon: ReactNode;
}): ReactNode {
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        fontSize: 13,
        color: "rgba(11,15,25,0.55)",
        cursor: "default",
        whiteSpace: "nowrap",
      }}
    >
      {props.icon}
      {props.label}
    </span>
  );
}

export function HeroVorgangShell(props: {
  readonly fixture: HeroVorgangFixture;
  readonly onBack?: () => void;
}): ReactNode {
  const t = useTranslations("marketing.heroVorgangShell");
  const fixture: HeroVorgangFixture = props.fixture;

  return (
    <div
      style={{
        flex: 1,
        minWidth: 0,
        display: "flex",
        flexDirection: "column",
        background: "#fff",
        height: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 11,
          padding: "12px 18px",
          borderBottom: "1px solid #F1F2F4",
          flexShrink: 0,
        }}
      >
        <button
          type="button"
          onClick={props.onBack}
          aria-label={t("zurueckListe")}
          style={{
            display: "inline-flex",
            border: "none",
            background: "transparent",
            color: "rgba(11,15,25,0.45)",
            cursor: props.onBack !== undefined ? "pointer" : "default",
            padding: 0,
            flexShrink: 0,
          }}
        >
          <ArrowLeft width={18} height={18} strokeWidth={1.8} />
        </button>
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            fontSize: 15,
            fontWeight: 700,
            color: "#0B0F19",
            minWidth: 0,
            flex: 1,
          }}
        >
          <span
            style={{
              color: "rgba(11,15,25,0.45)",
              display: "inline-flex",
              flexShrink: 0,
            }}
          >
            <FileText width={16} height={16} strokeWidth={1.9} />
          </span>
          <span
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {fixture.headerTitle}
          </span>
        </span>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 14,
            flexShrink: 0,
          }}
        >
          <HeaderAction
            label={t("nebenkonversation")}
            icon={<GitBranchPlus width={14} height={14} strokeWidth={1.8} />}
          />
          <HeaderAction
            label={t("filter")}
            icon={<ListFilter width={14} height={14} strokeWidth={1.8} />}
          />
          <HeaderAction
            label={t("aktionen")}
            icon={<EllipsisVertical width={14} height={14} strokeWidth={1.8} />}
          />
        </div>
      </div>

      <div style={{ display: "flex", flex: 1, minHeight: 0 }}>
        <div
          style={{
            position: "relative",
            flex: 1,
            minWidth: 0,
            minHeight: 0,
            overflow: "hidden",
            background: "#fff",
          }}
        >
          <HeroVorgangThread items={fixture.thread} />
          <HeroVorgangActionFooter />
        </div>
        {fixture.unknownContact !== null ? (
          <HeroVorgangUnknownPanel contact={fixture.unknownContact} />
        ) : fixture.rail !== null ? (
          <HeroVorgangDetailRail rail={fixture.rail} />
        ) : null}
      </div>
    </div>
  );
}
